var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableSearchIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74093 0.185547C3.51523 0.185547 0.90625 2.73472 0.90625 5.88648C0.90625 9.03824 3.51523 11.5874 6.74093 11.5874C7.89258 11.5874 8.95843 11.2573 9.86205 10.6966L14.0772 14.8151L15.5359 13.3899L11.3744 9.33429C12.1225 8.3754 12.5756 7.18727 12.5756 5.88648C12.5756 2.73472 9.96663 0.185547 6.74093 0.185547ZM6.74093 1.52694C9.21182 1.52694 11.2027 3.47223 11.2027 5.88648C11.2027 8.30073 9.21182 10.246 6.74093 10.246C4.27004 10.246 2.27912 8.30073 2.27912 5.88648C2.27912 3.47223 4.27004 1.52694 6.74093 1.52694Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableSearchIcon);
export default __webpack_public_path__ + "static/media/TableSearchIcon.153414b757b2c9b60c6d59f4fef644f0.svg";
export { ForwardRef as ReactComponent };